import React from "react";
import { COLORS } from "utils/styles";

const OrderedList = ({ children }) => {
  return (
    <ol className="custom__list list ma0 pa0 relative">
      {children}
      <style jsx>{`
        :global(ol.custom__list > li) {
          position: relative;
          counter-increment: list-counter;
          margin-top: .5em;
          margin-bottom: .5em;
          position: relative;
          padding-left: 1.75rem;
          list-style-position: inside;
          padding-top: 3px;
          line-height: 1.5;
        }
        :global(ol.custom__list > li > a) {
          color: ${COLORS.blue};
          font-weight: 500;
          text-decoration: none;
        }
        :global(ol.custom__list > li > a:hover) {
          text-decoration: underline !important;
          text-decoration-line: underline !important;
          text-decoration-style: initial !important;
          text-decoration-color: initial !important;
        }
        :global(ol.custom__list > li:before) {
          content: counter(list-counter) ".";
          position: absolute;
          font-weight: 400;
          color: #6b7280;
          left: 0;
      `}</style>
    </ol>
  );
};

export default OrderedList;
